import { z } from 'zod';
import { IdSchema, IsoDateTimeSchema, LocaleSchema, nullableText } from './common.js';
import { ProductListItemSchema } from './catalog.js';
/**
 * Qidiruv — mijoz tovarni asosan shu orqali topadi (moslik bazasi yo'q).
 *
 * Quvur: normalizatsiya (kichik harf, kirill→lotin) → artikulmi tekshirish →
 * so'zlarga bo'lish → HAR SO'ZNI ALOHIDA tuzatish (sinonim + o'xshashlik) →
 * Meilisearch → reyting (avtopart-search skill).
 */
export const SearchQuerySchema = z
    .object({
    q: z.string().trim().min(1).max(160),
    categoryId: IdSchema.optional(),
    brandId: IdSchema.optional(),
    shopId: IdSchema.optional(),
    inStockOnly: z.coerce.boolean().optional(),
    limit: z.coerce.number().int().min(1).max(50).default(24),
    offset: z.coerce.number().int().min(0).max(1000).default(0),
})
    .strict();
/** Facet — brend va kategoriya filtrlari Meilisearch'dan bepul keladi. */
export const SearchFacetSchema = z.object({
    value: z.string(),
    label: z.string(),
    count: z.number().int().nonnegative(),
});
export const SearchResponseSchema = z.object({
    /** Foydalanuvchi yozgani. */
    queryRaw: z.string(),
    /** Normalizatsiyadan keyingi shakl. */
    queryNorm: z.string(),
    /** Tuzatilgan bo'lsa — "tacker kalotka" → "tracker kolodka". */
    correctedTo: z.string().nullable(),
    /** So'rov artikul/OEM deb aniqlandimi — u holda tuzatish qo'llanmaydi. */
    isArticleLookup: z.boolean(),
    items: z.array(ProductListItemSchema),
    total: z.number().int().nonnegative(),
    facets: z.object({
        brands: z.array(SearchFacetSchema),
        categories: z.array(SearchFacetSchema),
    }),
    /** Meilisearch yiqilib pg_trgm ga tushilganini klient bilishi kerak. */
    degraded: z.boolean(),
    tookMs: z.number().int().nonnegative(),
});
/** Natijasiz so'rovlar — assortiment rejasining manbai. */
export const SearchLogResponseSchema = z.object({
    id: IdSchema,
    queryRaw: z.string(),
    queryNorm: z.string(),
    correctedTo: nullableText(160),
    resultsCount: z.number().int().nonnegative(),
    locale: LocaleSchema,
    createdAt: IsoDateTimeSchema,
});
export const SearchSynonymResponseSchema = z.object({
    id: IdSchema,
    term: z.string(),
    synonyms: z.array(z.string()),
});
export const UpsertSearchSynonymSchema = z
    .object({
    term: z.string().trim().min(1).max(64).toLowerCase(),
    synonyms: z.array(z.string().trim().min(1).max(64)).min(1).max(30),
})
    .strict();
//# sourceMappingURL=search.js.map